module.exports = __webpack_public_path__ + "static/media/lettuce.77b5e93e.jpg";